import { render } from "./EmployeeTagBoxComponent.vue?vue&type=template&id=55ddd0f6"
import script from "./EmployeeTagBoxComponent.vue?vue&type=script&lang=js"
export * from "./EmployeeTagBoxComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__